import request from "./../utils/request";

export const LEAD_API = {
    listForms: async (filters, cursor, sort) => {
        return request.post(
            "/meta/forms",
            { filters, cursor, sort },
            {
                timeout: 60 * 1000 * 5,
            }
        );
    },
    distinctAdFilters: async () => {
        return request.get("/meta/distinct-ad-filters", {
            timeout: 60 * 1000 * 5,
        });
    },
};

/**
 * Meta Marketing Insights API request'leri.
 * Tum metodlar tablet'in /api/meta/insights/* endpoint'lerine post atar.
 */
export const INSIGHTS_API = {
    listBusinessesByToken: async (accessToken) => {
        return request.post(
            "/meta/insights/businesses/by-token",
            { accessToken },
            { timeout: 60 * 1000 }
        );
    },
    listAdAccountsByBusinessId: async (accessToken, businessId) => {
        return request.post(
            "/meta/insights/ad-accounts/by-business",
            { accessToken, businessId },
            { timeout: 60 * 1000 }
        );
    },
    listPersonalAdAccountsByToken: async (accessToken) => {
        return request.post(
            "/meta/insights/ad-accounts/personal",
            { accessToken },
            { timeout: 60 * 1000 }
        );
    },
    listAdAccountsByToken: async (accessToken) => {
        return request.post(
            "/meta/insights/ad-accounts/by-token",
            { accessToken },
            { timeout: 60 * 1000 }
        );
    },
    listAdAccounts: async (channelId) => {
        return request.post(
            "/meta/insights/ad-accounts",
            { channelId },
            { timeout: 60 * 1000 }
        );
    },
    getAccountInsights: async (channelId, options) => {
        return request.post(
            "/meta/insights/account",
            Object.assign({ channelId }, options || {}),
            { timeout: 60 * 1000 * 2 }
        );
    },
    listCampaigns: async (channelId, options) => {
        return request.post(
            "/meta/insights/campaigns",
            Object.assign({ channelId }, options || {}),
            { timeout: 60 * 1000 * 2 }
        );
    },
    listAdSets: async (channelId, campaignId, options) => {
        return request.post(
            "/meta/insights/adsets",
            Object.assign({ channelId, campaignId }, options || {}),
            { timeout: 60 * 1000 * 2 }
        );
    },
    listAds: async (channelId, adsetId, options) => {
        return request.post(
            "/meta/insights/ads",
            Object.assign({ channelId, adsetId }, options || {}),
            { timeout: 60 * 1000 * 2 }
        );
    },
    getInsights: async (channelId, options) => {
        return request.post(
            "/meta/insights",
            Object.assign({ channelId }, options || {}),
            { timeout: 60 * 1000 * 2 }
        );
    },
};
